// Import & register Chart.js pieces
// ---------------------------------------
import { Chart, DoughnutController, ArcElement } from 'chart.js';
Chart.register(DoughnutController, ArcElement);

// Set global default settings/options
// ---------------------------------------
Chart.defaults.animation = false;
Chart.defaults.hover = { mode: null };
// Chart.defaults.responsive = false;
Chart.defaults.aspectRatio = 1;
Chart.defaults.datasets.doughnut.cutout = '72%';
Chart.defaults.datasets.doughnut.rotation = 180;
Chart.defaults.elements.arc.borderColor = 'transparent';
Chart.defaults.color = '#777';

// Set global variables
// ---------------------------------------
const charts = document.querySelectorAll('.doughnut-chart');
const miniCharts = document.querySelectorAll('.mini-doughnut-chart');
let hydratedTotalChart = null;
let hydratedSystemCharts = [];
let hydratedMiniSystemCharts = [];

// Functions
// ---------------------------------------
function getChartBenchmarkScore(chart) {
  return Number(chart.dataset.benchmarkScore);
}

/**
 * one-off function for generating the unique total chart
 */
export function generateTotalChart(chartScore) {
  // console.trace();

  const totalChart = document.querySelector('.total-doughnut-chart');
  const benchmarkScore = getChartBenchmarkScore(totalChart);

  // total chart config
  const totalChartConfig = {
    type: 'doughnut',
    data: {
      datasets: [
        {
          label: 'Benchmark Dataset',
          data: [benchmarkScore, 100 - benchmarkScore],
          backgroundColor: ['#E3E3E3', 'transparent'],
          weight: 1,
        },
        {
          label: 'System Dataset',
          data: [chartScore, 100 - chartScore],
          backgroundColor: ['#FF4F1F', '#FFFFFF'],
          weight: 2,
        },
      ],
    },
    // options: { },
  };

  const totalDoughnutChartCtx = totalChart.getContext('2d');
  hydratedTotalChart = new Chart(totalDoughnutChartCtx, totalChartConfig);

  // create a PNG version of the chart, for the sake of better browser support for exporting to PDF with the html2pdf tool
  makePngVersion(totalChart, hydratedTotalChart, 'system-summary');
}

/**
 * Generates the mini charts for the Systems
 * @param {object} totals - From `appState.totals`
 */
export function generateMiniSystemCharts(totals) {
  // console.log(miniCharts);
  miniCharts.forEach((chart) => {
    // console.log('chart: ', chart);
    const systemThemeColor = getComputedStyle(chart).getPropertyValue(
      '--system-theme-color'
    );
    const systemDashedName = chart.dataset.systemDashedName;
    const chartScore = Number(totals[`${systemDashedName}`].percentageScore);

    const systemChartConfig = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: 'System Dataset',
            data: [chartScore, 100 - chartScore],
            backgroundColor: [systemThemeColor, '#FFFFFF'],
            weight: 2,
          },
        ],
      },
      options: {
        cutout: '80%',
      },
    };

    const ctx = chart.getContext('2d');
    const systemName = chart
      .closest('.system-summary-chart-link')
      .querySelector('.title').textContent;
    const chartObj = {
      system: systemName,
      chart: new Chart(ctx, systemChartConfig),
    };
    hydratedMiniSystemCharts.push(chartObj);
  });
}

/**
 * Generates charts for the Systems, including benchmark values
 * @param {object} totals - From `appState.totals`
 */
export function generateSystemCharts(totals) {
  // console.log(charts);
  charts.forEach((chart) => {
    // console.log('chart: ', chart);
    const systemThemeColor = getComputedStyle(chart).getPropertyValue(
      '--system-theme-color'
    );
    const benchmarkScore = getChartBenchmarkScore(chart);
    const systemDashedName = chart.dataset.systemDashedName;
    const chartScore = Number(totals[`${systemDashedName}`].percentageScore);

    const systemChartConfig = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: 'Benchmark Dataset',
            data: [benchmarkScore, 100 - benchmarkScore],
            backgroundColor: ['#E3E3E3', 'transparent'],
            weight: 1,
          },
          {
            label: 'System Dataset',
            data: [chartScore, 100 - chartScore],
            backgroundColor: [systemThemeColor, '#F3F3F3'],
            weight: 2,
          },
        ],
      },
      // options: { },
    };

    const ctx = chart.getContext('2d');
    const systemName = chart.closest('.system-section').dataset.systemName;
    // console.log('systemName: ', systemName);
    const chartObj = {
      system: systemName,
      chart: new Chart(ctx, systemChartConfig),
    };
    hydratedSystemCharts.push(chartObj);

    // create a PNG version of the chart, for the sake of better browser support for exporting to PDF with the html2pdf tool
    makePngVersion(chart, chartObj.chart, systemDashedName);
  });
}

function makePngVersion(chartEl, chart, id) {
  // console.log('in makeImage. chart: ', chart, typeof chart);
  const base64 = chart.toBase64Image();

  var image = new Image();
  image.src = base64;
  image.id = `chart_img_ver-${id}`;
  image.classList.add('doughnut-chart-png');
  chartEl.closest('.doughnut-chart-container').prepend(image);
}

// /**
//  * Updates all of the charts. Uses the Chart.js update() method
//  */
// export function updateAllCharts() {
//   // console.trace();

//   // console.log('hydratedTotalChart: ', hydratedTotalChart);
//   if (hydratedTotalChart) {
//     hydratedTotalChart.update();
//   }
//   // hydratedTotalChart = null;

//   if (hydratedMiniSystemCharts.length) {
//     hydratedMiniSystemCharts.forEach((chart) => {
//       console.log('chart: ', chart);
//       chart.chart.update();
//     });
//   }

//   if (hydratedSystemCharts.length) {
//     hydratedSystemCharts.forEach((chart) => {
//       console.log('chart: ', chart);
//       chart.chart.update();
//     });
//   }
// }

// /**
//  * Resizes all of the charts. Uses the Chart.js resize() method
//  */
// export function resizeAllCharts() {
//   // console.trace();

//   // console.log('hydratedTotalChart: ', hydratedTotalChart);
//   if (hydratedTotalChart) {
//     hydratedTotalChart.resize();
//   }
//   // hydratedTotalChart = null;

//   if (hydratedMiniSystemCharts.length) {
//     hydratedMiniSystemCharts.forEach((chart) => {
//       console.log('chart: ', chart);
//       chart.chart.resize();
//     });
//   }

//   if (hydratedSystemCharts.length) {
//     hydratedSystemCharts.forEach((chart) => {
//       console.log('chart: ', chart);
//       chart.chart.resize();
//     });
//   }
// }

/**
 * Destroys all of the charts. Uses the Chart.js destroy() method, and also resets storage variables to null.
 */
export function destroyAllCharts() {
  // console.trace();

  // console.log('hydratedTotalChart: ', hydratedTotalChart);
  if (hydratedTotalChart) {
    hydratedTotalChart.canvas.parentNode
      .querySelector('.doughnut-chart-png')
      .remove(); // remove generated PNG image
    hydratedTotalChart.destroy();
  }
  hydratedTotalChart = null;

  // console.log('hydratedMiniSystemCharts: ', hydratedMiniSystemCharts);
  if (hydratedMiniSystemCharts.length) {
    hydratedMiniSystemCharts.forEach((hChart) => {
      hChart.chart.destroy();
    });
  }
  hydratedMiniSystemCharts = [];

  // console.log('hydratedSystemCharts: ', hydratedSystemCharts);
  if (hydratedSystemCharts.length) {
    hydratedSystemCharts.forEach((hChart) => {
      // console.log('chart: ', hChart.chart);
      hChart.chart.canvas.parentNode
        .querySelector('.doughnut-chart-png')
        .remove(); // remove generated PNG image
      hChart.chart.destroy();
    });
  }
  hydratedSystemCharts = [];
}
